// Environment configuration
export const config = {
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL || '',
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
  },
  // Edge function endpoints
  livekitTokenEndpoint: `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/livekit-token`,
  dispatchAgentEndpoint: `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/dispatch-agent`,
};

// Validation
if (!config.supabase.url) {
  console.warn('REACT_APP_SUPABASE_URL is not set');
}

if (!config.supabase.anonKey) {
  console.warn('REACT_APP_SUPABASE_ANON_KEY is not set');
}
